import { SECTION_COPY } from "../copy";
import { resolveLifeArea, useLifeAreas } from "../lifeAreas";
import LifeAreaTile from "./LifeAreaTile";

/**
 * LIFE_AREAS (Figma node 9285:17268) — always present, every Life Area.
 *
 * Falls back to the life-areas list if the feed section carries no items, so the
 * one guaranteed section is never empty.
 */
function LifeAreasSection({ section, onOpenLifeArea }) {
  const known = useLifeAreas();
  const fromFeed = section?.items?.length > 0 ? section.items : null;
  const items = fromFeed || known;

  const c = SECTION_COPY.LIFE_AREAS;

  return (
    <section className="ex-section">
      <div className="ex-section__head">
        <h2 className="ex-section__title">{c.title}</h2>
        <p className="ex-section__subtitle">{c.subtitle}</p>
      </div>

      <div className="ex-areas">
        {items.map((item, i) => {
          const area = resolveLifeArea(item);
          return (
            <button
              key={area.key || i}
              type="button"
              className="ex-area"
              onClick={() => onOpenLifeArea?.(area.key)}
            >
              <LifeAreaTile area={area} className="ex-area__tile" />
              <span className="ex-area__text">
                <span className="ex-area__title">{area.title}</span>
                {area.description && (
                  <span className="ex-area__desc">{area.description}</span>
                )}
              </span>
              <span className="ex-area__chevron">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path
                    d="M9 6l6 6-6 6"
                    stroke="currentColor"
                    strokeWidth="1.9"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </span>
            </button>
          );
        })}
      </div>
    </section>
  );
}

export default LifeAreasSection;
